import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { roi, date } = payload[0]?.payload;
    return (
      <div
        style={{
          padding: "10px",
          color: "#333",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <div className="flex gap-2">
          <strong style={{ margin: 0, color: "#333" }}>ROI:</strong>
          <p style={{ color: "#333" }}>{roi}%</p>
        </div>
        <div className="flex gap-2">
          <strong style={{ margin: 0, color: "#333" }}>Date:</strong>
          <p style={{ color: "#333" }}>{date}</p>
        </div>
      </div>
    );
  }
  return null;
};

const CustomLegend = () => (
  <div className="text-center text-[#57FFFF] font-bold mt-2"></div>
);

const ReturnComponent = ({ graphROI }) => {
  const transformedData = graphROI.chart_data?.map((item) => ({
    date: item.date,
    value: item.value,
    roi: item.roi,
  }));

  const formatXAxis = (tickItem) => {
    return moment(tickItem).format("DD MMM");
  };

  return (
    <div className="border p-5 border-gray-600">
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={transformedData}>
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#00BFFF" />
              <stop offset="100%" stopColor="#00BFFF" />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="0 1" stroke="#ccc" />
          <XAxis
            dataKey="date"
            tickFormatter={formatXAxis}
            axisLine={false}
            tick={{ fill: "white", fontSize: 12 }}
            tickLine={false}
            angle={-30}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            minTickGap={10}
            tick={{ fill: "white", fontSize: 12 }}
            tickFormatter={(value) => `${value}%`}
          />
          <Tooltip content={<CustomTooltip />} cursor={false} />
          <Line
            type="monotone"
            dataKey="roi"
            stroke="url(#colorGradient)"
            dot={false}
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReturnComponent;
